<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!story">Update Story</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="story">Add Story</h1>

                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User ID</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter User ID"
                                           v-model="storyAdd.user_id" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User Type</b></label>
                                    <select class="form-control" v-model="storyAdd.user_type" required>
                                        <option value="1">Student</option>
                                        <option value="2">Company</option>
                                        <option value="3">Employee</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label><b>Story Short Text</b></label>
                            <input type="text" class="form-control"
                                   placeholder="Enter Short Text"
                                   v-model="storyAdd.short_text"
                                   required name="short_text"
                                   v-validate="'required|max:255'">
                            <small v-if="errors.has('short_text')" class="text-danger">
                                {{ errors.first('short_text') }}
                            </small>
                        </div>
                        <div class="form-group mb-3">
                            <label><b>Story Description</b></label>
                            <editor v-model="storyAdd.success_story_text" v-validate="'required|min:10'"
                                    name="success_story_text"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="news description"
                                    required></editor>
                            <small v-if="errors.has('success_story_text')" class="text-danger">
                                {{ errors.first('success_story_text') }}
                            </small>
                        </div>


                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!story"
                                    @click="update_story()">UPDATE
                            </button>
                            <button type="button" class="btn btn-primary" v-if="story" @click="add_story()">ADD
                            </button>
                            <router-link :to="{name: 'website-stories'}" class="btn my-4 btn-secondary">
                                Back
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
  name: "CreateStories",
  components: { Editor },
  data() {
    return {
      storyAdd: {},
      story: true
    };
  },
  methods: {
    add_story: function() {
      this.storyAdd.access_token = localStorage.getItem("access_token");
      this.storyAdd.admin_id = localStorage.getItem("admin_id");
      axios({
        method: "POST",
        url: "admin/success-stories/new",
        data: this.storyAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Story Added Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    },
    getsingleStory() {
      axios({
        url:
          "/admin/success-stories/" +
          this.$route.params.story_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.storyAdd = result.data.success_story;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_story: function() {
      this.storyAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url: "/admin/success-stories/update/" + this.$route.params.story_id,
        data: this.storyAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Story Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.story_id > 0) {
      this.story = false;
      this.getsingleStory();
    } else {
      this.storyAdd = {};
      this.story = true;
    }
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
